module.exports = __webpack_public_path__ + "img/b.b8600714.jpg";